module.exports = __webpack_public_path__ + "img/p_费用控制@2x.025a8105.png";